module.exports = __webpack_public_path__ + "img/goto.e33639d.png";